import React from "react";

interface StatusDotProps {
  status: "active" | "warning" | "error" | "inactive";
  className?: string;
}

export function StatusDot({ status, className = "" }: StatusDotProps) {
  const statusColors = {
    active: "bg-status-active",
    warning: "bg-status-warning",
    error: "bg-status-error",
    inactive: "bg-status-inactive",
  };

  return (
    <span
      className={`inline-block w-2 h-2 rounded-full ${statusColors[status]} ${className}`}
    />
  );
}
